import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/ADD_BILL_PAYER';
export const {action: show} = createAction(
    `${domain}/SHOW`,
    (institutionId, childId, editingBillPayer, persist = false, validationPayload = null) => ({
        institutionId,
        childId,
        editingBillPayer,
        persist,
        validationPayload,
    }),
);

export const {action: showWithExistingSplit} = createAction(
    `${domain}/SHOW_WITH_EXISTING_SPLIT`,
    (institutionId, childId, editingSplitConfiguration, editingBillPayer, persist = false) => ({
        institutionId,
        childId,
        editingSplitConfiguration,
        editingBillPayer,
        persist,
    }),
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {
    action: search,
    success: searchSuccess,
    failed: searchFailed,
    aborted: searchAborted,
} = createAction(`${domain}/SEARCH`, (institutionId, childId, term, initial = false) => ({
    institutionId,
    childId,
    term,
    initial,
}));

export const {
    action: saveBillPayer,
    success: saveBillPayerSuccess,
    failed: saveBillPayerFailed,
} = createAction(
    `${domain}/SAVE`,
    (institutionId, billPayer, sensitiveInformation) => ({institutionId, billPayer, sensitiveInformation}),
    billPayer => ({billPayer}),
);

export const {
    action: discontinueBillPayer,
    success: discontinueBillPayerSuccess,
    failed: discontinueBillPayerFailed,
} = createAction(`${domain}/DISCONTINUE`, (institutionId, billPayerId) => ({institutionId, billPayerId}));

export const {
    action: reviveBillPayer,
    success: reviveBillPayerSuccess,
    failed: reviveBillPayerFailed,
} = createAction(`${domain}/REVIVE`, (institutionId, billPayerId) => ({institutionId, billPayerId}));

export const {
    action: reviveBillPayerAndAddToChild,
    success: reviveBillPayerAndAddToChildSuccess,
    failed: reviveBillPayerAndAddToChildFailed,
} = createAction(
    `${domain}/REVIVE_AND_ADD_TO_CHILD`,
    (institutionId, billPayerId, persist, addBillPayerToChildActionData) => ({
        institutionId,
        billPayerId,
        persist,
        addBillPayerToChildActionData,
    }),
);

export const {
    action: addBillPayerToChild,
    success: addBillPayerToChildSuccess,
    failed: addBillPayerToChildFailed,
} = createAction(
    `${domain}/ADD_BILL_PAYER_TO_CHILD`,
    (
        institutionId,
        childId,
        existingChildBillPayers,
        existingChildSplitConfiguration,
        newBillPayerData,
        sensitiveInformation,
    ) => ({
        institutionId,
        childId,
        existingChildBillPayers,
        existingChildSplitConfiguration,
        newBillPayerData,
        sensitiveInformation,
    }),
    (institutionId, childId, suggestedSplitConfiguration) => ({institutionId, childId, suggestedSplitConfiguration}),
);

export const {action: setCandidateBillPayers} = createAction(
    `${domain}/SET_CANDIDATE_BILL_PAYERS`,
    candidateBillPayers => ({candidateBillPayers}),
);
